import { render, staticRenderFns } from "./BotaoRastreabilidadeRaizen.vue?vue&type=template&id=4605c25f&lang=pug"
import script from "./BotaoRastreabilidadeRaizen.vue?vue&type=script&lang=js"
export * from "./BotaoRastreabilidadeRaizen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports